import type { Chart, IAxisLabelRenderEventArgs } from '@syncfusion/ej2-charts';

export async function barchart(appendTo: string, data: any) {

    await import('./loadSyncfusion');

    const { Chart, StackingColumnSeries, Category, Tooltip, Legend } = await import('@syncfusion/ej2-charts');

    Chart.Inject(StackingColumnSeries, Category, Tooltip, Legend);

    const chartData = data.map((item: any) => {
        const totalMacros = item.Protein + item.Carbs + item.Fat || 1; // Prevent division by zero
        const proteinRatio = item.Protein / totalMacros;
        const carbsRatio = item.Carbs / totalMacros;
        const fatRatio = item.Fat / totalMacros;

        return {
            Date: new Date(item.Date),
            ProteinRatio: proteinRatio * item.Kcal,
            CarbsRatio: carbsRatio * item.Kcal,
            FatRatio: fatRatio * item.Kcal,
            FiberGrams: item.Fiber ?? 0,
            Protein: item.Protein,
            Carbs: item.Carbs,
            Fat: item.Fat,
            Fiber: item.Fiber ?? 0,
            ProteinPercent: Math.round(proteinRatio * 100),
            CarbsPercent: Math.round(carbsRatio * 100),
            FatPercent: Math.round(fatRatio * 100),
            Kcal: item.Kcal
        };
    });

    const chart: Chart = new Chart({
        primaryXAxis: {
            valueType: 'Category',
            majorGridLines: { width: 0 },
            labelStyle: { color: '#fff' },
            labelIntersectAction: 'Hide'
        },
        primaryYAxis: {
            majorGridLines: { width: 1, color: '#777' }, // Add horizontal grid lines
            lineStyle: { width: 0 },
            labelStyle: { color: '#fff' },
            titleStyle: { color: '#fff' },
            title: 'Calories (KCal)'
        },
        series: [
            {
                type: 'StackingColumn',
                dataSource: chartData,
                xName: 'Date',
                yName: 'ProteinRatio',
                name: 'Protein',
                columnWidth: 0.3, // Adjusted to make bars skinnier
                fill: '#FFA500'
            },
            {
                type: 'StackingColumn',
                dataSource: chartData,
                xName: 'Date',
                yName: 'CarbsRatio',
                name: 'Carbs',
                columnWidth: 0.3, // Adjusted to make bars skinnier
                fill: '#00BFFF'
            },
            {
                type: 'StackingColumn',
                dataSource: chartData,
                xName: 'Date',
                yName: 'FatRatio',
                name: 'Fat',
                columnWidth: 0.3, // Adjusted to make bars skinnier
                fill: '#FF4500'
            }
        ],
        //tooltip: {
        //    enable: true,
        //    format: '${point.x} <br> ${series.name}: ${point.y} Kcal',
        //    template: '<div>${point.x} <br> ${series.name}: ${point.point.tooltipValue}g (${point.point.tooltipPercent}%)</div>'
        //},
        legendSettings: { visible: true, textStyle: { color: '#fff' } },
        background: 'transparent',
        width: '100%',
        height: '100%',
        axisLabelRender: (args: IAxisLabelRenderEventArgs) => {
            if (args.axis.name === 'primaryXAxis') {
                const date = new Date(args.text);
                const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
                args.text = date.toLocaleDateString('en-NZ', options);
            }
        },
        //tooltipRender: (args: ITooltipRenderEventArgs) => {
        //    const pointData = args.data.;
        //    const seriesName = args.series.name;
        //    const originalGrams = pointData[seriesName];
        //    const percentage = pointData[`${seriesName}Percent`];

        //    args.text = `${args.point.x} <br> ${seriesName}: ${originalGrams}g (${percentage}%)`;
        //}
    });

    chart.appendTo(appendTo);
}
